const serverConfigs = require('./server.js')
export const ENV = process.env.VUE_APP_MODE
export const server = serverConfigs[ENV]

export const host = server.host
export const passportHost = server.passportHost

// export const host = server.host
// export const passportHost = server.passportHost
export default {
  // host: 'http://localhost:8090',
  // passportHost: 'http://localhost:8090/api/v1',
  // host: 'https://test-passport.czur.cc',
  // passportHost: 'https://test-passport.czur.cc/api/v1',
  // host: 'https://passport.czur.cc',
  // passportHost: 'https://passport.czur.cc/api/v1',
  // host: 'https://test-passport.czur.cc',
  // passportHost: 'https://test-passport.czur.cc/api/v1',
  host: server.host,
  passportHost: server.passportHost,
  env: ENV,
  APP_KEY: 'CZUR_PASSPORT_WEB',
  CHANNEL: 'ALL', // 'CN', 'US', 'ALL'
  DEFAULT_PAGE: 'basic.html',
  HTTP_HEADER_KEY: {
    APP_KEY: 'App-Key',
    UDID: 'udid',
    CHANNEL: 'Channel',
    TOKEN: 'T-ID',
    USERID: 'U-ID'
  },
  COOKIE_KEY: {
    U_ID: 'U-ID',
    TOKEN: 'T-ID',
    USER_NAME: 'user',
    LANG: 'lang'
  },
  CALL_BACK: '',
  R_CODE: {
    SUCCESS: 1000,
    INTERNAL_ERROR: 1001,
    INVALID_TOKEN: 1002,
    BAD_ACCESS: 1003,
    PWD_ERROR: 1004,
    USER_INACTIVE: 1005,
    CHANNEL_UNSUPPORT: 1006,
    INVALID_MOBILE: 1007,
    INVALID_EMAIL: 1008,
    SMS_MANY_REQUEST: 1009,
    SMS_SEND_10S: 1010,
    USER_EXIST: 1011,
    MAIL_MANY_REQUEST: 1012,
    MAIL_SEND_10S: 1013,
    INVALID_CODE: 1014,
    IMG_PRO_ERROR: 1015,
    IMG_PRO_ING: 1016,
    INVALID_USER_NAME: 1017,
    USER_NO_EXIST: 1018,
    TIME_OUT: 1019,
    IMG_NOT_FOUND: 1020,
    DEVICE_OCCUPIED: 1021,
    USER_USING_DEVICE: 1022,
    MANY_REQUEST_CODE: 1023,
    PWD_OLD_SAME: 1030,
    PWD_OLD_ERROR: 1031,
    NO_MOBILE_BIND: 1032,
    CODE_ERROR: 1033,
    MOBILE_USED_OTHERS: 1034,
    EMAIL_USED_OTHERS: 1035
  },
  getChannel: function () {
    var channel = this.getReqParam('Channel')
    if (!channel) {
      channel = this.CHANNEL
    }
    return channel
  },
  cookieSet: function (key, value) {
    var Days = 30
    var date = new Date()
    date.setTime(date.getTime() + Days * 24 * 60 * 60 * 1000)
    document.cookie = key + '=' + escape(value) + '; path=/;expires = ' + date.toGMTString()
  },
  cookieGet: function (key) {
    var result
    var mycookie = document.cookie
    var start2 = mycookie.indexOf(key + '=')
    if (start2 > -1) {
      var start = mycookie.indexOf('=', start2) + 1
      var end = mycookie.indexOf(';', start)
      if (end === -1) {
        end = mycookie.length
      }
      result = unescape(mycookie.substring(start, end))
    }
    return result
  },
  getReqParam: function (param) {
    var url = window.location.search // 获取url中"?"符后的字串
    var theRequest = {}
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1)
      var strs = str.split('&')
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1])
      }
    }
    return theRequest[param]
  },
  appendParam: function (url, param, value) {
    var archor = ''
    if (url.indexOf('#') > 0) {
      var strs = url.split('#')
      url = strs[0]
      archor = strs[1]
    }
    if (url.indexOf('?') >= 0) {
      url = url + '&'
    } else {
      url = url + '?'
    }
    url = url + param + '=' + encodeURIComponent(value)
    if (archor !== '') {
      url = url + '#' + archor
    }
    return url
  },
  getLocalStore: function (key) {
    return localStorage.getItem(key)
  },
  setLocalStore: function (key, value) {
    localStorage.setItem(key, value)
  },
  lang: function () {
    var requestLang = this.getReqParam('lang')
    var currentLang = this.cookieGet('lang')
    if (requestLang !== undefined && requestLang !== '' && requestLang !== currentLang) {
      currentLang = requestLang
      this.cookieSet('lang', currentLang)
    }
    if (!currentLang) {
      currentLang = navigator.language   // 判断除IE外其他浏览器使用语言
      if (!currentLang) { // 判断IE浏览器使用语言
        currentLang = navigator.browserLanguage
      }
    }
    if (currentLang !== 'en' && currentLang !== 'zh-CN' && currentLang !== 'zh-TW' && currentLang !== 'ru_RU') {
      currentLang = 'en'
    }
    return currentLang
  },
  local4Service: function () {
    var lang = this.lang()
    var local = lang.replace('-', '_')
    return local
  },
  urlRemoveParam: function (param) {
    var url = window.location.href
    if (window.location.search.indexOf(param[0]) >= 0) {
      var hosturl = url.replace(window.location.search, '').replace(window.location.hash, '')
      var params = window.location.search.substr(1)
      var strs = params.split('&')
      for (var m = 0; m < param.length; m++) {
        var one = param[m]
        for (var i = 0; i < strs.length; i++) {
          if (strs[i].indexOf(one) >= 0) {
            strs.splice(i, 1)
            break
          }
        }
      }
      if (strs.length > 0) {
        var search = strs.join('&')
        hosturl = hosturl + '?' + search
      }
      url = hosturl + window.location.hash
    }
    return url
  }
}



// WEBPACK FOOTER //
// ./src/common/script/config.js